import type { AudioProperties, ImageProperties, VideoProperties } from "@skilitics/assets";
import { extractAudioProperties, extractImageDimensions, extractVideoProperties } from "@skilitics/assets";

import { transformModelFile } from "./transformModelFile.ts";
import type { UploadOptions } from "./types.ts";

export const imageAssetUploadOptions: UploadOptions<ImageProperties> = {
  mediaTypes: ["image" as const],
  mimeType: "image/*",
  onFileSelected: extractImageDimensions,
};

export const modelAssetUploadOptions: UploadOptions = {
  mediaTypes: ["model" as const],
  mimeType: ".glb,.gltf",
  transformFile: transformModelFile,
};

export const videoAssetUploadOptions: UploadOptions<VideoProperties> = {
  mediaTypes: ["video" as const],
  mimeType: "video/*",
  onFileSelected: async (file) => {
    const url = URL.createObjectURL(file);
    try {
      return await extractVideoProperties(url);
    } finally {
      URL.revokeObjectURL(url);
    }
  },
};

export const audioAssetUploadOptions: UploadOptions<AudioProperties> = {
  mediaTypes: ["audio" as const],
  mimeType: "audio/*",
  onFileSelected: async (file) => {
    const url = URL.createObjectURL(file);
    try {
      return await extractAudioProperties(url);
    } finally {
      URL.revokeObjectURL(url);
    }
  },
};
